import { Tabs } from "@portal/BaseComponents/Tab/AntTab";
import { Style } from "@portal/lib/style/style";

export const PortalTab = Style(Tabs, {
  "&.ant-tabs": {
    background: "var(--gray-1)",
    position: "relative",

    "&.ant-tabs-top > .ant-tabs-nav::before": {
      border: 0,
    },
    ".ant-tabs-nav": {
      margin: 0,
      paddingInline: "120px",
    },
    ".ant-tabs-tabpane": {
      backgroundColor: "var(--background-1) !important",
    },

    ".ant-tabs-nav-wrap": {
      height: "60px",
    },
    "&.ant-tabs-content-holder": {},
    "&.ant-tabs .ant-tabs-content": {
      position: "static",
    },
  },
});
